/**
 * @author wuTao
 * @description 学员评语明细
 * @Date 2020/11/05
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool} from '@/tool';
import 'antd/dist/antd.css';

let {WizContainer, modelUtils} = framework_tool;
let {WizRow,WizCol,WizLayout,WizSpin,WizTypography} = component_tool;
const { Header, Content } = WizLayout;
const { Title } = WizTypography
import '@/styles/components/question/questionPreview/index.less'
import moment from "moment";
import classnames from "classnames";
import { QsInput } from '@/components/questionnaire/components/components';

const Comp = (props) => {
  const { CompName, index, pathCommentDetailedName,answer,id,key } = props
  const otherProps = {
    index,key,
    id: id,
    title: pathCommentDetailedName,
    answer: answer,
    options: [],
    otherAnswer: '',
    img: -1,
    type: 5
  };
  return (
    <div className={classnames("qs-item","normal")}>
      <div className="qs-item-title">
        <strong>{index + 1}、{ pathCommentDetailedName }</strong>
      </div>
      <div className="qs-item-content">
        <div className="answer"><CompName { ...otherProps } /></div>
      </div>
    </div>
  )
}
class StudentCommentDetail extends WizContainer {
  componentName = "studentCommentDetail";

  constructor(props) {
    super(props)
    let { record } = props
    this.state = {
      recordNew:null,
      timestamp: new Date().getTime()
    }
    this.studentCommentOld= record;
  }

  _componentWillMount() {
    let {record} = this.props;
    if (record && record.id) {
      this.getStudentCommentDetail(record.id);
    }
  }

  propsAndStateOnChange = {
    studentCommentDetail: this._getStudentCommentDetail.bind(this),
  };

  /**
   * 获取返回数据
   * @param nextProps
   * @param nextState
   * @private
   */
  _getStudentCommentDetail(nextProps, nextState) {
    if (nextProps.studentCommentDetail.code === 1) {
      this.setState({
        recordNew:nextProps.studentCommentDetail.data,
      });
    } else {
      wizNotice.error(nextProps.studentCommentDetail.msg);
    }
    return true;
  }

  /**
   * 获取 学员路径评语明细信息
   * @param values
   * @private
   */
  getStudentCommentDetail(id) {
    let apiPath = "studentCommentManagement/selectOneById";
    let payloadKey = "studentCommentManagement@studentCommentDetail";
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          id: id,
        }
      }
    });
  }

  _renderHead(){
    const {recordNew} = this.state
    return(
      <div className="question-header">
        <WizRow className='question-header-title' type='flex' justify='center' align='middle'>
          <WizCol span={20}>
            <Title className='header-title' level={4}>{recordNew && recordNew.pathCommentName}</Title>
          </WizCol>
        </WizRow>
        <WizRow type='flex' justify={'end'} align='middle'>
          <WizCol>
            <div><span>提交人：{recordNew && recordNew.submiterFullName }({recordNew && recordNew.submiterUserName})</span><span style={{ margin: '0 20px 0 45px' }}>提交时间：{recordNew && moment(recordNew.submitTime).format('YYYY-MM-DD HH:mm')}</span></div>
          </WizCol>
        </WizRow>
      </div>
    )
  }

  _renderContent(){
    const {recordNew} = this.state
    if (recordNew && recordNew.detailInfoList && recordNew.detailInfoList instanceof Array && recordNew.detailInfoList.length>0){
      const Comps =recordNew.detailInfoList.map((val, index) => {
        const otherProps = {
          key: val.id,
          index,
          ...val
        }
        let comp = <Comp CompName = { QsInput } { ...otherProps } /> //填空题 //单行文本题
        return comp;
      })
      return(
        <div className="question-content">
          {Comps}
        </div>
      )
    }else {
      return (<div className="question-content"></div>);
    }
  }

  _render() {
    return (
      <WizLayout className="full-layout question-preview">
        <Header>
          {this._renderHead()}
        </Header>
        <Content>
          {this._renderContent()}
        </Content>
      </WizLayout>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {studentCommentManagement} = state;
  const studentCommentDetail = modelUtils.getModelEntity(studentCommentManagement, 'studentCommentManagement@studentCommentDetail');
  const load = modelUtils.getLoadingState(state, ['studentCommentManagement']);
  return {
    studentCommentDetail: studentCommentDetail,
    load
  };
};

const options = {withRef: true};

export default connect(mapStateToProps, null, null, options)(StudentCommentDetail);
